<html>
    <head></head>
    <body>
        <div style="text-align: center;padding: 20px;font-size: 200px;padding-top: 94px;color:#736a6a">404</div>
        <h1 style="text-align: center;color:#736a6a">Page Not Found</h1>
    </body>

</html>